import React from 'react'

import { SxProps, Theme } from '@mui/material'

export enum NotificationColorTypeEnum {
  error = 'error',
  warning = 'warning',
  info = 'info',
  success = 'success',
}

export type NotificationProps = {
  children: React.ReactNode
  open: boolean
  colorType: NotificationColorTypeEnum
  icon: boolean | React.ReactNode
  onClose?: () => void
  onClick?: () => void
  action?: React.ReactNode
  styles?: SxProps<Theme>
}
